import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  DirectusService,
  EvaluationCriteria,
  EvaluationSubCriteriaDirectus,
} from '@frontend/directus';
import {
  EvaluationCriteriaOverviewControllerService,
  EvaluationCriteriaOverviewResponse,
  GetEvaluationCriteriaOverviewRequestParams,
} from '@frontend/shared-api';

@Injectable({providedIn: 'root'})
export class Step43CriteriaWeightsOverviewService {
  private readonly directusService = inject(DirectusService);
  private readonly overviewController = inject(EvaluationCriteriaOverviewControllerService);

  loadOverview(projectId: number): Observable<EvaluationCriteriaOverviewResponse[]> {
    const request: GetEvaluationCriteriaOverviewRequestParams = {projectId};

    return this.overviewController.getEvaluationCriteriaOverview(request);
  }

  loadDirectusCriteria(): Observable<EvaluationCriteria[]> {
    return this.directusService.loadEvaluationCriteria();
  }

  loadDirectusSubCriteria(): Observable<EvaluationSubCriteriaDirectus[]> {
    return this.directusService.loadSubCriteria();
  }
}
